import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { AnimSplitText } from "@readdy/anim/header/split-text/react";

export default function HeroSection() {
  const { t } = useTranslation();
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    const mql = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReducedMotion(mql.matches);
    const handler = (e: MediaQueryListEvent) => setReducedMotion(e.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, []);

  return (
    <section className="relative w-full bg-background-950 overflow-hidden flex flex-col justify-center md:aspect-[2.5/1] lg:aspect-[3/1]">
      {/* Mobile: real image, full width, natural height — no crop, no zoom, no filter */}
      <img
        src="https://static.readdy.ai/image/2ebecee6eab69a8f2e29d29113a1fa62/0d078dc523e8b9805c5d5b80f16b6b94.png"
        alt="Clés Dormakaba Penta cross"
        className="block md:hidden w-full h-auto"
      />

      {/* Desktop: background image cover — starts below the navbar so it never overlaps the nav links */}
      <div
        className="hidden md:block absolute top-20 left-0 right-0 bottom-0 bg-cover bg-center"
        style={{
          backgroundImage: `url("https://static.readdy.ai/image/2ebecee6eab69a8f2e29d29113a1fa62/0d078dc523e8b9805c5d5b80f16b6b94.png")`,
        }}
      ></div>

      {/* Bottom fade to next section (desktop only) */}
      <div className="hidden md:block absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-background-950 to-transparent z-10"></div>

      <div className="relative z-20 w-full px-4 md:px-8 lg:px-16 py-10 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14 lg:gap-16 max-w-6xl mx-auto">
          {/* Text side */}
          <div className="flex-1 w-full text-center lg:text-left">
            {reducedMotion ? (
              <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-extrabold text-background-50 leading-tight tracking-tight">
                {t("brand")}
              </h1>
            ) : (
              <AnimSplitText stagger={50}>
                <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-extrabold text-background-50 leading-tight tracking-tight">
                  {t("brand")}
                </h1>
              </AnimSplitText>
            )}
            <div className="flex items-center justify-center lg:justify-start gap-3 mt-3 md:mt-4">
              <p className="font-heading text-base md:text-lg lg:text-xl text-white font-medium">
                {t("hero.tagline")}
              </p>
            </div>
            <Link
              to="/contact"
              className="inline-block mt-6 md:mt-8 px-8 py-3 md:px-10 md:py-3.5 bg-primary-500 text-background-50 rounded-full font-medium text-sm md:text-base cursor-pointer whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              {t("hero.cta")}
            </Link>
            <p className="mt-4 md:mt-5 text-xs md:text-sm text-background-50/50 font-light tracking-wide">
              {t("hero.operatingSince")}
            </p>
          </div>

          {/* Right side spacer - keys are now in background */}
          <div className="flex-1 w-full max-w-sm md:max-w-lg lg:max-w-2xl hidden lg:block"></div>
        </div>
      </div>
    </section>
  );
}